module.exports = __webpack_public_path__ + "img/jo_portrait.f8c806c8.jpeg";